const { algoErrorMessages } = require('./AlgoErrorMessages');
const { staticErrorMessage } = require('./StaticErrorMessage');
const { APIErrorMessages } = require('./APIErrorMessages');

module.exports = { algoErrorMessages, staticErrorMessage, APIErrorMessages };
